"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateCarUsageSubformDriversLogResults = void 0;
const utils_1 = require("../utils");
const utils_2 = require("./utils");
const validateDriversLogAmounts = (inputs) => {
    // Ignoring the following rule as we are destructing the object to omit the unused values.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { carExpenses, carExpensesWithTaxDeduction, carType } = inputs, numberValues = __rest(inputs, ["carExpenses", "carExpensesWithTaxDeduction", "carType"]);
    const amounts = Object.values(numberValues);
    const carExpensesAmounts = Object.values(carExpenses);
    const carExpensesWithTaxDeductionAmounts = Object.values(carExpensesWithTaxDeduction);
    (0, utils_1.validateAmounts)([
        ...amounts,
        ...carExpensesAmounts,
        ...carExpensesWithTaxDeductionAmounts,
    ]);
};
const sumCarExpenses = (expenses) => Object.values(expenses).reduce((sum, value) => sum + value, 0);
/**
 * Returns the [106] Private car usage which is based on the car expenses to calculate
 * the price per km (sum of all net car expenses (19% & 0%) / total km traveled).
 * Some car expenses (depreciation & leasing costs) are recalculated based on the car type
 * before the price per km is obtained.
 * Result will be given by the privateKm * pricePerKm.
 */
const getPrivateCarUsage = ({ carExpenses, carExpensesWithTaxDeduction, totalKm, privateKm, carType, }) => {
    const carTypeCostValue = utils_2.CAR_TYPE_COST_VALUE[carType];
    const carTypeBasedCarExpenses = Object.assign(Object.assign({}, carExpenses), { depreciationCosts: carExpenses.depreciationCosts * carTypeCostValue, leasingCosts: carExpenses.leasingCosts * carTypeCostValue });
    const carTypeBasedCarExpensessWithTaxDeduction = Object.assign(Object.assign({}, carExpensesWithTaxDeduction), { depreciationCosts: carExpensesWithTaxDeduction.depreciationCosts * carTypeCostValue, leasingCosts: carExpensesWithTaxDeduction.leasingCosts * carTypeCostValue });
    // Price per Km = sum of all net car expenses (19% & 0%) / total km traveled.
    const pricePerKm = totalKm > 0
        ? (sumCarExpenses(carTypeBasedCarExpenses) +
            sumCarExpenses(carTypeBasedCarExpensessWithTaxDeduction)) /
            totalKm
        : 0;
    return Math.round(privateKm * pricePerKm);
};
const calculateCarUsageSubformDriversLogResults = (inputs, declarationYear) => {
    if (declarationYear <= 0) {
        throw new Error("Invalid declaration year");
    }
    validateDriversLogAmounts(inputs);
    const { carType, commuteDistance, commuteDays, totalKm, privateKm, homeCompanyKm, carExpenses, carExpensesWithTaxDeduction, } = inputs;
    // Price per Km = sum of all net car costs (19% & 0%) / total km traveled.
    const pricePerKm = totalKm > 0
        ? (sumCarExpenses(carExpenses) +
            sumCarExpenses(carExpensesWithTaxDeduction)) /
            totalKm
        : 0;
    // [106] Private Kfz-Nutzung
    const privateCarUsage = getPrivateCarUsage({
        carExpenses,
        carExpensesWithTaxDeduction,
        totalKm,
        privateKm,
        carType,
    });
    // [140] Vereinnahmte USt 19 %
    const collectedVat = totalKm > 0
        ? Math.round(sumCarExpenses(carExpensesWithTaxDeduction) *
            (privateKm / totalKm) *
            utils_2.VAT_RATE)
        : 0;
    // [142] Fahrten zwischen Wohnung/Betrieb
    const homeCompanyTrips = Math.round(homeCompanyKm * pricePerKm);
    // [176] Min. abziehbare Fahrtkosten
    const minDeductibleTravelExpenses = (0, utils_2.getMinDeductibleTravelExpenses)({
        commuteDays,
        commuteDistance,
        declarationYear,
    });
    // Gewinnerhöhung = [106] + [140] + [142] - [176]
    const profitIncrease = privateCarUsage +
        collectedVat +
        homeCompanyTrips -
        minDeductibleTravelExpenses;
    return {
        privateCarUsage,
        collectedVat,
        homeCompanyTrips,
        minDeductibleTravelExpenses,
        profitIncrease,
    };
};
exports.calculateCarUsageSubformDriversLogResults = calculateCarUsageSubformDriversLogResults;
//# sourceMappingURL=driversLog.js.map